import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { AnimatePresence } from "framer-motion"
import Measure from 'react-measure'
import { NavLink } from 'react-router-dom'

import { FaChevronLeft } from 'react-icons/fa'
import { Animation, Paper, Tabs, Particles } from 'components'
import { LoginScreen, RegisterScreen, ForgotPasswordScreen, DeeplinkScreen } from 'screens'

const Background = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: var(--secondary-color); */
    /* border: 1px solid red; */
    position: absolute;
`

const Back = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    color: var(--text-color);
    padding: 0.5rem;
    margin: 1rem;
    :hover {
        text-decoration: underline;
    };
`

const Container = styled.div`
    border-radius: 5px;
    width: 25rem;
    /* min-height: 50vh; */
    background-color: var(--primary-color);
    display: flex;
    flex-direction: column;
    padding: 3rem;
    overflow: hidden;
    position: relative;
`


const Header = styled.div`

`

const Title = styled.div`
    font-weight: bolder;
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: ${props => props.screen === 'forgot_password' ? '0' : '1.5rem'};
`

const AuthScreen = props => {
    const {
        type,
        premium
    } = props;
    const [screen, setScreen] = React.useState(type)
    const [boundingRect, setBounds] = React.useState(null)
    const pathName = new URL(window.location['href'])
    const redirectId = pathName.searchParams.get('id')

    React.useEffect(() => {
        premium && localStorage.setItem('redirect', 'settings-subscription')
    }, [])

    const tabOptions = {
        login: 'Login',
        register: 'Register'
    }
    const tabStyles = {
        main: {
            width: '100%',
            backgroundColor: 'var(--primary-color)'
        },
        tab: {
            width: null,
            padding: '0.5rem 0.3rem 0.5rem 0.3rem',
            borderRadius: 0,
        }
    }

    const content = screen === 'login' ? <LoginScreen tabHandler={setScreen} redirectId={redirectId}/>
                    : screen === 'register' ? <RegisterScreen tabHandler={setScreen} redirectId={redirectId}/>
                    : screen === 'forgot_password' ? <ForgotPasswordScreen tabHandler={setScreen}/>
                    : screen === 'deeplink' ? <DeeplinkScreen redirectId={redirectId}/>
                    : <div>Something went wrong</div>

    const title = screen === 'login' ? 'Welcome back'
                : screen === 'register' ? 'Get started today'
                : screen === 'forgot_password' ? 'Forgot password'
                : 'Something went wrong'

    return (
        <Particles>
            <Background>
                {process.env.REACT_APP_ENV === 'PRODUCTION' ? <Back onClick={() => { window.location = 'https://atomicly.io' }}><FaChevronLeft/></Back> 
                : <NavLink to='/' exact><Back><FaChevronLeft/></Back></NavLink>}
                
                <Paper>
                    <Container>
                        {screen !== 'deeplink' && 
                        <Header>
                            <Title screen={screen}>{title}</Title>
                            {screen !== 'forgot_password' ? <Tabs type='plain' styles={tabStyles} options={tabOptions} selected={screen} onSelect={setScreen}/> : null}
                        </Header>}
                        {content}
                    </Container>
                </Paper>
            </Background>
        </Particles>
    )
}

export default AuthScreen